import { useState, useContext, forwardRef } from 'react';
import { Button } from 'remote-com-shared/components/Button';
import {
  Navigation,
  NavigationSecondary,
} from 'remote-com-shared/components/HeaderNavigation/styles/Navigation';
import HeroContext from 'remote-com-shared/components/Hero/context';
import { useBreakpointRange } from 'remote-com-shared/style/breakpoints';
import { whenProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import { Wrapper, RemoteLogo } from './styles';
import { BrandContainer, Brand } from './styles/Brand';

import {
  fromDesktopBreakpoint,
  fromLargeDesktopBreakpoint,
} from '@/src/domains/shared/breakpoints';

const WrapperPosition = styled.div`
  position: relative;
  font-family: var(--typography-fontBrand);
`;

const CTAMobile = styled.div`
  display: block;

  ${fromLargeDesktopBreakpoint(css`
    display: none;
  `)}
`;

export const CTAButton = styled(Button)`
  && {
    background-color: var(--colors-blank);
    color: var(--colors-darkBlue);
    text-transform: uppercase;
    font-family: var(--typography-fontBrand);
    ${({ theme }) => theme.typography.subHead}
  }

  && {
    ${whenProp(
      ['$isFixed', '$isOpen'],
      css`
        color: var(--colors-blank);
        background-color: var(--colors-irisBlue);
      `
    )}
  }
`;

const CustomCTAHeader = forwardRef(function CustomCTAHeader(props, ref) {
  const { brandHref = '/', brandSuffix, cta, headerCtaLink, headerCtaLabel } = props;
  const { isIntersecting } = useContext(HeroContext);
  const [isOpen, setIsOpen] = useState(false);

  useBreakpointRange(
    { to: fromDesktopBreakpoint },
    {
      onLeave: () => setIsOpen(false),
    }
  );

  return (
    <WrapperPosition>
      <Wrapper $isOpen={isOpen} $isFixed={!isIntersecting} ref={ref} {...props}>
        <BrandContainer $isOpen={isOpen} $isFixed={!isIntersecting}>
          <Brand as="a" aria-label="Visit homepage" href={brandHref}>
            <RemoteLogo $isOpen={isOpen} $isFixed={!isIntersecting} />
            {brandSuffix && brandSuffix({ $isOpen: isOpen, $isFixed: !isIntersecting })}
          </Brand>

          <CTAMobile>
            {cta ||
              (headerCtaLink && headerCtaLabel && (
                <CTAButton
                  href={headerCtaLink?.url}
                  target={headerCtaLink?.target}
                  $isOpen={isOpen}
                  $isFixed={!isIntersecting}
                >
                  {headerCtaLabel || 'Learn more'}
                </CTAButton>
              ))}
          </CTAMobile>
        </BrandContainer>

        <Navigation $isOpen={isOpen} aria-hidden={!isOpen}>
          <NavigationSecondary>
            {cta ||
              (headerCtaLink && headerCtaLabel && (
                <CTAButton
                  href={headerCtaLink?.url}
                  target={headerCtaLink?.target}
                  $isOpen={isOpen}
                  $isFixed={!isIntersecting}
                >
                  {headerCtaLabel || 'Learn more'}
                </CTAButton>
              ))}
          </NavigationSecondary>
        </Navigation>
      </Wrapper>
    </WrapperPosition>
  );
});

export default CustomCTAHeader;
